/** @jsxImportSource @emotion/react */

import { Form, Input, InputProps } from "antd";
import { ValidateStatus } from "antd/es/form/FormItem";
import { Control, Controller, FieldValues } from "react-hook-form";

import { InputCustomStyle } from "./index.style";

export interface InputCustomType extends InputProps {
  margin_bottom?: string;
  name?: string;
  control?: Control<FieldValues | any>;
  errors?: string;
  validate_status?: ValidateStatus;
  defaultValue?: string | number;
  width?: string;
  label?: string;
  onChangeCustom?: (
    value: string,
    event?: React.ChangeEvent<HTMLInputElement>
  ) => void;
}

const InputCustom = (props: InputCustomType) => {
  const {
    name = "",
    control,
    margin_bottom,
    errors,
    validate_status,
    defaultValue = "",
    width,
    label,
    onChange: onChangeProps,
    onChangeCustom,
  } = props;
  const inputProps = { ...props };

  delete inputProps.onChange;
  delete inputProps.onChangeCustom;

  return (
    <>
      {control ? (
        <Form.Item
          // className="non-reset"
          css={InputCustomStyle.self}
          label={
            label ? (
              <p style={{ fontSize: "16px", color: "white" }}>{label}</p>
            ) : null
          }
          help={errors}
          validateStatus={validate_status}
          style={{
            marginBottom: margin_bottom ? margin_bottom : "20px",
            width: width ? width : "100%",
          }}
          labelCol={{ span: 24 }}
        >
          <Controller
            name={name}
            defaultValue={defaultValue}
            control={control}
            render={({ field: { onChange, value } }) => {
              const handleChange = (
                event: React.ChangeEvent<HTMLInputElement>
              ) => {
                onChange(event);
                onChangeProps?.(event);
                onChangeCustom?.(event.target.value, event);
              };

              return (
                <Input onChange={handleChange} value={value} {...inputProps} />
              );
            }}
          />
        </Form.Item>
      ) : (
        <Input
          {...inputProps}
          css={InputCustomStyle.self}
          onChange={(event) => {
            onChangeProps?.(event);
            onChangeCustom?.(event.target.value, event);
          }}
        />
      )}
    </>
  );
};

export default InputCustom;
